import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from '../shared/error-handler.service';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';
import { catchError, map, Observable } from 'rxjs';
import { DTO } from 'src/app/models/supplier-portal/supplier/supplierDTOS.models';

@Injectable({
  providedIn: 'root',
})
export class OrderProcessingService {
  private readonly serviceBase = environment.urlServer;
  private readonly orderProcessingEnpoints = {
    getCertificationByID: (id_certification: number) =>
      `${this.serviceBase}/get_certification/${id_certification}/`,
    putCertificationDDT: `${this.serviceBase}/put_certification_ddt/`,
    putCertificationBatch: `${this.serviceBase}/put_certification_batch/`,
    putCertificationFile: `${this.serviceBase}/put_certification_file/`,
    deleteCertificationFile: `${this.serviceBase}/del_certification_file/`,
    deleteCertificationDDT: `${this.serviceBase}/del_certification_ddt/`,
    closeCertification: `${this.serviceBase}/close_certification/`,
    validateCertificationFile: `${this.serviceBase}/validate_certification_file/`,
  } as const;

  public constructor(
    private readonly http: HttpClient,
    private readonly errorHandlerServ: ErrorHandlerService,
  ) { }

  public getCertificationByID(
    id_certification: number,
  ): Observable<ProcessingOrders.Certification> {
    return this.http
      .get<DTO.IDefaultResponseDTO>(
        this.orderProcessingEnpoints.getCertificationByID(id_certification),
      )
      .pipe(
        map((response) => {
          return new ProcessingOrders.Certification(response.data);
        }),
        catchError(
          this.errorHandlerServ.handleError<any>('getCertificationByID'),
        ),
      );
  }

  public putCertificationDDT(payload: ProcessingOrders.IDDT) {
    return this.http
      .post<ProcessingOrders.IDDT>(
        this.orderProcessingEnpoints.putCertificationDDT,
        payload,
      )
      .pipe(
        catchError(
          this.errorHandlerServ.handleError<ProcessingOrders.IDDT>(
            'putCertificationDDT',
          ),
        ),
      );
  }

  public putCertificationBatch(payload: ProcessingOrders.IBatchToAdd) {
    return this.http
      .post<DTO.IDefaultResponseDTO | ProcessingOrders.IProductBatch>(
        this.orderProcessingEnpoints.putCertificationBatch,
        payload,
      )
      .pipe(
        catchError(
          this.errorHandlerServ.handleError<
            DTO.IDefaultResponseDTO | ProcessingOrders.IProductBatch
          >('putCertificationBatch'),
        ),
      );
  }

  public putCertificationFile(payload: ProcessingOrders.IFile) {
    return this.http
      .post<ProcessingOrders.IFile>(
        this.orderProcessingEnpoints.putCertificationFile,
        payload,
      )
      .pipe(
        catchError(
          this.errorHandlerServ.handleError<ProcessingOrders.IFile>(
            'putCertificationFile',
          ),
        ),
      );
  }

  public deleteCertificationFile(certification_document_id: number) {
    return this.http
      .post(
        this.orderProcessingEnpoints.deleteCertificationFile,
        { certification_document_id },
      )
      .pipe(
        catchError(
          this.errorHandlerServ.handleError<unknown>(
            'deleteCertificationFile',
          ),
        ),
      );
  }

  public deleteCertificationDDT(certification_id: number) {
    return this.http
      .post(
        this.orderProcessingEnpoints.deleteCertificationDDT,
        { certification_id },
      )
      .pipe(
        catchError(
          this.errorHandlerServ.handleError<unknown>('deleteCertificationDDT'),
        ),
      );
  }

  public closeCertification(certification_id: number) {
    return this.http
      .post(this.orderProcessingEnpoints.closeCertification, { certification_id })
      .pipe(
        catchError(
          this.errorHandlerServ.handleError<unknown>('closeCertification'),
        ),
      );
  }

  public validateCertificationFile(
    certification_document_id: number,
    check: 'S' | 'N' | '',
  ) {
    return this.http
      .post(this.orderProcessingEnpoints.validateCertificationFile, {
        certification_document_id,
        check,
      })
      .pipe(
        catchError(
          this.errorHandlerServ.handleError<unknown>(
            'validateCertificationFile',
          ),
        ),
      );
  }
}
